import React from 'react';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="dark-header">
        <Link to="/" className="dark-logo-text">NIRAIE</Link>
        <nav className="dark-nav">
          <a href="/#features" className="dark-nav-link">Features</a>
          <a href="/#pricing" className="dark-nav-link">Pricing</a>
          <a href="/#faq" className="dark-nav-link">FAQ</a>
          <Link to="/contact" className="dark-nav-link">Contact</Link>
          <button className="btn-primary">Get Started</button>
        </nav>
      </header>

      {/* Policy Hero */}
      <section className="policy-hero">
        <div className="policy-hero-content">
          <h1 className="page-title">Terms & Conditions</h1>
          <p className="page-subtitle">Last updated: December 13, 2024</p>
        </div>
      </section>

      {/* Policy Content */}
      <section className="policy-section">
        <div className="policy-container">
          <div className="policy-content">
            <h2 className="policy-heading">1. Acceptance of Terms</h2>
            <p className="policy-text">
              By accessing or using Niraie's AI Tax Chat Engine, you agree to be bound by these Terms and Conditions. 
              If you do not agree with any part of these terms, you may not use our service. These terms apply to all 
              visitors, users, and others who access or use the service.
            </p>

            <h2 className="policy-heading">2. Service Description</h2>
            <p className="policy-text">
              Niraie provides an AI-powered tax consultation service that offers answers to tax-related questions. 
              Our service includes:
            </p>
            <ul className="policy-list">
              <li>Free tier: 3 questions per user</li>
              <li>Premium tier: Unlimited questions for ₹200/month (including taxes)</li>
              <li>AI-generated responses based on current tax laws and regulations</li>
              <li>24/7 availability of the chat engine</li>
            </ul>

            <h2 className="policy-heading">3. User Responsibilities</h2>
            <p className="policy-text">
              When using our service, you agree to:
            </p>
            <ul className="policy-list">
              <li>Provide accurate and complete information</li>
              <li>Not use the service for any illegal or unauthorized purpose</li>
              <li>Not attempt to gain unauthorized access to our systems</li>
              <li>Not share your account credentials with others</li>
              <li>Not submit false, misleading, or fraudulent queries</li>
              <li>Comply with all applicable laws and regulations</li>
            </ul>

            <h2 className="policy-heading">4. Disclaimer of Professional Advice</h2>
            <p className="policy-text">
              <strong>IMPORTANT:</strong> The information provided by Niraie's AI Tax Chat Engine is for general 
              informational purposes only and does not constitute professional tax advice. While we strive for accuracy, 
              we do not guarantee that the information is complete, accurate, or up-to-date. You should consult with 
              a qualified tax professional for advice specific to your situation.
            </p>

            <h2 className="policy-heading">5. Subscription and Payments</h2>
            <p className="policy-text">
              For premium subscriptions:
            </p>
            <ul className="policy-list">
              <li>Subscription fee is ₹200 per month (all taxes included)</li>
              <li>Billing occurs on a monthly recurring basis</li>
              <li>You can cancel your subscription at any time</li>
              <li>Cancellation takes effect at the end of the current billing period</li>
              <li>No refunds for partial months unless specified in our Refund Policy</li>
              <li>We reserve the right to change pricing with 30 days notice</li>
            </ul>

            <h2 className="policy-heading">6. Intellectual Property Rights</h2>
            <p className="policy-text">
              All content, features, and functionality of the Niraie service, including but not limited to text, 
              graphics, logos, and software, are owned by Niraie and are protected by copyright, trademark, and 
              other intellectual property laws. You may not reproduce, distribute, or create derivative works without 
              our express written permission.
            </p>

            <h2 className="policy-heading">7. Limitation of Liability</h2>
            <p className="policy-text">
              To the maximum extent permitted by law, Niraie shall not be liable for any indirect, incidental, special, 
              consequential, or punitive damages, including but not limited to loss of profits, data, or goodwill, 
              arising from:
            </p>
            <ul className="policy-list">
              <li>Your use or inability to use the service</li>
              <li>Any inaccuracies or errors in the AI-generated responses</li>
              <li>Unauthorized access to your data</li>
              <li>Any other matter relating to the service</li>
            </ul>

            <h2 className="policy-heading">8. Account Termination</h2>
            <p className="policy-text">
              We reserve the right to suspend or terminate your account at any time for:
            </p>
            <ul className="policy-list">
              <li>Violation of these Terms and Conditions</li>
              <li>Fraudulent or illegal activity</li>
              <li>Non-payment of subscription fees</li>
              <li>Abusive behavior towards our system or staff</li>
            </ul>
            <p className="policy-text">
              You may terminate your account at any time by contacting our support team.
            </p>

            <h2 className="policy-heading">9. Service Modifications</h2>
            <p className="policy-text">
              We reserve the right to modify, suspend, or discontinue any part of the service at any time without 
              notice. We are not liable to you or any third party for any modification, suspension, or discontinuation 
              of the service.
            </p>

            <h2 className="policy-heading">10. Governing Law</h2>
            <p className="policy-text">
              These Terms and Conditions are governed by and construed in accordance with the laws of India. 
              Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts 
              in Bangalore, Karnataka.
            </p>

            <h2 className="policy-heading">11. Changes to Terms</h2>
            <p className="policy-text">
              We may revise these Terms and Conditions at any time. We will notify users of material changes via 
              email or through the service. Your continued use of the service after such changes constitutes your 
              acceptance of the new terms.
            </p>

            <h2 className="policy-heading">12. Contact Information</h2>
            <p className="policy-text">
              For questions about these Terms and Conditions, please contact us at:
            </p>
            <p className="policy-text">
              <strong>Email:</strong> niraiethechatengine@gmail.com<br />
              <strong>Phone:</strong> +91 93859 32082<br />
              <strong>Address:</strong> 97G/10/1 Teachers Colony, 5th Street West, Tuticorin-628008
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="dark-footer">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">NIRAIE</div>
            <p className="footer-tagline">AI-Powered Tax Intelligence for Everyone</p>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Product</h4>
            <ul className="footer-links">
              <li><a href="/#features">Features</a></li>
              <li><a href="/#pricing">Pricing</a></li>
              <li><a href="/#faq">FAQ</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Support</h4>
            <ul className="footer-links">
              <li><Link to="/contact">Contact</Link></li>
              <li><a href="#">Help Center</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 Niraie. All rights reserved.</p>
        </div>
      </footer>

      {/* Custom Credit Badge */}
      <div className="custom-credit">
        <span>Made with</span>
        <a href="https://sukraconsolv.com" target="_blank" rel="noopener noreferrer" className="custom-credit-link">
          SUKRA CONSOLV
        </a>
      </div>
    </div>
  );
};

export default TermsAndConditions;
